// Environment configuration for API endpoints
// This handles both local development and Azure deployment

interface ApiConfig {
  baseUrl: string
  environment: 'development' | 'production'
}

// Use environment variable for API URL (injected at build time via Vite)
// VITE_API_URL should be set in Azure App Service configuration or .env file
const apiUrl = import.meta.env.VITE_API_URL

// Fallback detection for local development if no env var set
const isLocal = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')

export const apiConfig: ApiConfig = {
  baseUrl: apiUrl || (isLocal ? 'http://localhost:5010/api' : ''),
  environment: isLocal ? 'development' : 'production'
}

// Validate configuration
if (!apiConfig.baseUrl) {
  throw new Error('API URL is not configured. Set VITE_API_URL environment variable.')
}

export default apiConfig